<template>
  <v-container>
    <h1>{{ $t('settings.qualifications-title') }}</h1>
    <p>{{ $t('settings.qualifications-info') }}</p>

    <template v-if="!tcForProfession">
      <template v-if="lGet(currentUser, 'educations', []).length">
        <h4>{{ $t('labels.education') }}</h4>
        <p>{{ $t('settings.education-info-v2') }}</p>

        <v-expansion-panels class="mt-4 certificate">
          <v-expansion-panel
              v-for="item in currentUser.educations"
              :key="item.id"
              :aria-label="getProfessionNameById(item.professionId)"
          >
            <v-expansion-panel-header expand-icon="$sl-arrow-down">
              <div>
                <div class="header-title">
                  {{ getProfessionNameById(item.professionId) }}
                </div>
                <div class="header-sub-title gray">{{ $t('labels.education-year') }} {{ getYear(item.endDate) }}</div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <h6>{{ $t('labels.education-type') }}</h6>
              <p v-if="item.type">
                {{ getEducationName(item.type) || $t('labels.no-data') }}
              </p>
              <h6>{{ $t('labels.education') }}</h6>
              <p v-if="item.extendedInfo && item.extendedInfo.schoolName">
                {{ item.extendedInfo.schoolName || $t('labels.no-data') }}
              </p>
              <p v-else>{{ $t('labels.no-data') }}</p>
              <h6>{{ $t('labels.education-provider') }}</h6>
              <p v-if="item.extendedInfo && item.extendedInfo.program">
                {{ item.extendedInfo.program }}
              </p>
              <p v-else>{{ $t('labels.no-data') }}</p>
              <h6>{{ $t('labels.education-year') }}</h6>
              <p>{{ getYear(item.endDate) || $t('labels.missing-info') }}</p>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>

      <template v-else>
        <MessageBox class="mb-7" type="info">
          <h6>{{ $t('settings.education-missing-title') }}</h6>
          <p>{{ $t('settings.education-missing-text') }}</p>
          <p>
            <a :href="links.education.certificates" target="_blank">{{ $t('settings.education-missing-link') }}</a>
          </p>
        </MessageBox>
      </template>
    </template>

    <h4>{{ $t('settings.certificates-title') }}</h4>
    <template v-if="currentUser && tradeCertificates && tradeCertificates.length > 0">
      <p>{{ $t('settings.certificate-info') }}</p>

      <v-expansion-panels class="mt-4 certificate">
        <template v-for="item in tradeCertificates">
          <v-expansion-panel
              v-if="item.approvedById && item.approvedById > 0"
              :aria-label="item.title"
              :key="item.id"
          >
            <v-expansion-panel-header expand-icon="$sl-arrow-down">
              <div>
                <div class="header-title">
                  {{ item.title }} {{ getMachinesCert(item) }}
                </div>
                <div class="header-sub-title gray">
                  {{ $t('settings.created-of-BYN') }}
                  {{ getRegionNameById(item.regionId) }} {{ item.issuedOn | date }}
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-if="!item.machinesCert">
                <h6>{{ $t('company.certificate-by') }}</h6>
                <p v-if="item.regionId">BYN {{ getRegionNameById(item.regionId) || '' }}</p>
                <h6>{{ $t('company.certificate-date') }}</h6>
                <p v-if="item.approvedOn">
                  {{ item.approvedOn | date }}
                </p>
              </div>
              <div v-for="machineCert in item.machinesCert">
                <h6>{{ $t('company.certificate-by') }} {{ machineCert.machine.name }}</h6>
                <p v-if="item.regionId">BYN {{ getRegionNameById(machineCert.regionId) || '' }}</p>
                <h6>{{ $t('company.certificate-date') }} {{ machineCert.machine.name }} </h6>
                <p v-if="item.approvedOn">
                  {{ machineCert.approvedOn | date }}
                </p>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </template>
      </v-expansion-panels>

      <ActionButton type="application" class="mt-4" actionIcon="$sl-invitation" @click="openInstructorCard = true">{{
          $t('company.qr1-title')
        }}
      </ActionButton>

      <ActionButton
          class="mt-4 mb-6"
          type="application"
          v-if="tradeCertId > 0"
          @click="openHashModal('tradeCert', tradeCertId)"
          actionIcon="$sl-qr"
      >{{ $t('company.get-qr') }}
      </ActionButton
      >
    </template>

    <template v-else>
      <MessageBox class="mb-7" type="info">
        <h6>{{ $t('settings.certificates-missing-title') }}</h6>
        <p>{{ $t('settings.certificates-missing-info') }}</p>
        <p>
          <a target="_blank" :href="links.education.diplomaInfo">{{ $t('settings.certificates-missing-link') }}</a>
        </p>
      </MessageBox>
    </template>

    <template
        v-if="guTimeQualifications.length > 0 || qTimeQualifications.length > 0">
      <h4>{{ $t('company.machine-type') }}</h4>
      <p>{{ $t('company.machine-certificate-text', {name: $t('company.you')}) }}</p>
      <template v-if="guTimeQualifications.length > 0">
        <h5 v-if="showTitles && guTimeQualifications.length > 0">
          {{ $t('company.gu-title') }}
        </h5>
        <v-list>
          <template v-for="(item, index) in guTimeQualifications">
            <v-list-item class="height-large" :key="'dis_' + item.id">
              <v-list-item-content>
                <v-list-item-title class="text-uppercase" v-html="item.machine.name"></v-list-item-title>
                <v-list-item-subtitle v-if="item.region && item.region.name"
                >{{ $t('settings.created-of-BYN2') }}
                  {{ item.region.name || '' }}
                  {{ datesGU.startDate | date }}
                </v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
            <v-divider :key="index"></v-divider>
          </template>
        </v-list>
        <ActionButton type="application" class="mt-4" actionIcon="$sl-invitation" @click="showGUCard()">{{
            $t('company.qr1-title')
          }}
        </ActionButton>
        <ActionButton
            class="mt-4 mb-6"
            type="application"
            v-if="guTimeQualifications[0].educationId"
            @click="openHashModal('distance', guTimeQualifications[0].educationId)"
            actionIcon="$sl-qr"
        >{{ $t('company.get-qr') }}
        </ActionButton
        >
      </template>

      <template v-if="qTimeQualifications.length > 0">
        <h5 v-if="showTitles">
          {{ $t('company.qTime-title') }}
        </h5>
        <v-list>
          <template v-for="(item, index) in qTimeQualifications">
            <v-list-item class="height-large" :key="'qTime_' + index">
              <v-list-item-content>
                <v-list-item-title class="text-uppercase" v-html="item.machine.name"></v-list-item-title>
                <v-list-item-subtitle v-if="datesQTime.startDate && item.region.name"
                >{{ $t('settings.created-of-BYN2') }}
                  {{ item.region.name || '' }}
                  {{ datesQTime.startDate | date }}
                </v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
            <v-divider :key="index"></v-divider>
          </template>
        </v-list>
        <ActionButton
            type="application"
            class="mt-4"
            v-if="qTimeQualifications.length > 0"
            actionIcon="$sl-invitation"
            @click="openQtimeCard = true"
        >{{ $t('company.qr1-title') }}
        </ActionButton
        >
        <ActionButton
            class="mt-4 mb-4"
            type="application"
            v-if="qTimeQualifications.length > 0"
            @click="openHashModal('education', qTimeQualifications[0].educationId)"
            actionIcon="$sl-qr"
        >{{ $t('company.get-qr') }}
        </ActionButton
        >
      </template>
    </template>

    <v-dialog class="certificate" persistent v-model="openInstructorCard" max-width="344px">
      <QualificationModal
          :items="instQualifications"
          :machineItems="instMachineQualifications"
          :isInstructor="true"
          @close="openInstructorCard = false"
      ></QualificationModal>
    </v-dialog>
    <v-dialog class="certificate" persistent v-model="openGUCard" max-width="344px">
      <QualificationModal
          :items="guTimeQualifications"
          :date="datesGU"
          :isGU="true"
          @close="openGUCard = false"
      ></QualificationModal>
    </v-dialog>
    <v-dialog class="certificate" persistent v-model="openQtimeCard" max-width="320px">
      <QualificationModal
          :items="qTimeQualifications"
          :date="datesQTime"
          :isGU="false"
          @close="openQtimeCard = false"
      ></QualificationModal>
    </v-dialog>

    <v-dialog persistent v-model="openQr" max-width="320px">
      <v-card flat>
        <v-icon size="20" class="close" @click="closeQrModal">$sl-close</v-icon>
        <h2>{{ $t('company.qr-title') }}</h2>
        <qrcode-vue :value="qrValue" size="262" class="d-flex justify-center mb-7"></qrcode-vue>
        <!--
         Dont remove, to open the qr-url
        <p>
          <a :href="qrValue" target="_blank">{{ qrValue }}</a>
        </p> -->

        <p v-html="$t('company.qr-text')"></p>
        <p>
          <a :href="links.settings.qrCode" target="_blank">{{ $t('company.qr-readmore') }}</a>
        </p>
      </v-card>
    </v-dialog>

    <v-card flat v-if="isInstructor(0) == true">
      <h4 class="mt-7">{{ $t('settings.instructions-title') }}</h4>
      <p>{{ $t('settings.instructions-info') }}</p>

      <template v-if="shouldReadInstructions">
        <MessageBox class="mb-7" type="warning">
          <h6>{{ $t('settings.instructions-updated-title') }}</h6>
          <p>{{ $t('settings.instructions-updated-info') }}</p>
          <p>
            <a :href="links.main.bynInstructorInstructions" target="_blank">{{
                $t('settings.instructions-updated-link')
              }}</a>
          </p>
        </MessageBox>
      </template>
      <template v-else>
        <v-list two-line>
          <v-list-item-group :multiple="false" :mandatory="false">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title v-html="$t('labels.instructor-instruction')"></v-list-item-title>
                <v-list-item-subtitle v-if="currentUser && currentUser.readInstructionsOn"
                >{{ $t('settings.confirmed') }} {{ currentUser.readInstructionsOn | date }}
                </v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </template>
      <v-divider></v-divider>
      <v-list two-line v-if="currentUser.diversequalifications">
        <v-list-item-group :multiple="false" :mandatory="false">
          <v-list-item v-for="(q, index) in currentUser.diversequalifications" :key="index">
            <v-list-item-content>
              <v-list-item-title>{{ lGet(q, 'diversequalificationtype.name', '-') }}</v-list-item-title>
              <v-list-item-subtitle>{{ $t('settings.added') }} {{ q.issuedOn | date }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <ActionButton
          v-if="shouldReadInstructions"
          actionIcon="$sl-save"
          class="mt-5"
          @click="
          $nextTick(() => {
            $router.push({name: 'InstructorInstructions'})
          })
        "
      >{{ $t('labels.confirm-instructor-instruction') }}
      </ActionButton
      >
    </v-card>
  </v-container>
</template>

<script>
import API from "@/services/api.js";
import {mapActions, mapGetters} from "vuex";
import MessageBox from "@/components/Common/MessageBox";
import ActionButton from "@/components/Common/ActionButton";
import QualificationModal from "@/components/Qualification/qualificationModal";
import {InstructorAbilities} from '@/components/mixins'
import find from "lodash/find";
import get from "lodash/get";
import QrcodeVue from "qrcode.vue";

const SugarDate = require("sugar/date");

// @group People
// Styled MyQualifications component
export default {
  name: 'MyQualifications',

  mixins: [InstructorAbilities],

  data: () => ({
    links: require('../../lib/external-links.json'),
    openQr: false,
    openGUCard: false,
    openQtimeCard: false,
    openInstructorCard: false,
    showTitles: false,
    shouldReadInstructions: true,
    maQualifications: [],
    datesGU: {},
    datesQTime: {},
    qTimeQualifications: [],
    guTimeQualifications: [],
    instQualifications: [],
    instMachineQualifications: [],
    newInstructionsDate: Date.new,
    qrValue: '',
    selectedMachine: {},
    tradeCertId: 0,
    educationTypes: [],
    tradeCertificates: []
  }),
  watch: {
    currentUser: {
      handler: function () {
        this.init();
        //this.needToRead();
      },
      deep: true
    }
  },
  components: {
    MessageBox,
    ActionButton,
    QrcodeVue,
    QualificationModal
  },
  created() {
    this.init()
    this.getInstructions()
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isInstructor', 'isCompanyUser']),
    ...mapGetters('basic', [
      'basicProfessions',
      'getProfessionById',
      'hasProfessionOrientations',
      'getProfessionNameById',
      'getProfessionIconById',
      'getRegionNameById',
      'systemSettings'
    ]),

    tcForProfession() {
      if ( !get(this, 'currentUser.tradeCertificates', []).length )
        return false

      const professionIds = get(this, 'currentUser.tradeCertificates', []).map(tc => tc.professionId)

      return get(this, 'currentUser.educations', []).every(e => professionIds.includes(e.professionId))
    }
  },
  filters: {
    persno: function (value) {
      if (!value || value.length < 10) return ''
      return value.substring(2, 8) + '-' + value.substring(8, 12)
    }
  },
  methods: {
    lGet: get,

    getMachinesCert(item) {
      if (!item.machinesCert) {
        return ''
      }

      return '(' + item.machinesCert.map(it => it.machine.name).join('/') + ')';
    },

    init() {
      this.listEducationTypes()
          .then(() => {
            if (this.currentUser && this.currentUser.tradeCertificates) {
              let obj = {}
              let prof = {}
              this.instQualifications = []
              this.currentUser.tradeCertificates.forEach(tr => {
                obj = {}
                if (!this.hasProfessionOrientations(tr.professionId)) {
                  prof = this.getProfessionById(tr.professionId)
                  if (tr.approvedById && tr.approvedById > 0 && prof) {
                    obj.id = tr.id
                    obj.profession = prof
                    obj.educationId = tr.educationId
                    obj.approvedOn = tr.approvedOn
                    obj.regionId = tr.regionId
                    obj.issuedOn = tr?.issuedOn
                    this.instQualifications.push(obj)

                    this.tradeCertificates.push({...tr, ...{title: this.getProfessionNameById(tr.professionId)}})

                    if ((tr.numCopies || 0) > 0) {
                      this.tradeCertificates.push({
                        ...tr, ...{
                          id: (tr.id | 0x1000000),
                          issuedOn: tr.lastCopyDate,
                          title: this.getProfessionNameById(tr.professionId) + " (" + this.$i18n.t("order-card.trade-certificate-duplicate") + ")"
                        }
                      })
                    }
                  }
                } else {
                  prof = this.getProfessionById(tr.professionId)
                  //- Show all machines that user has qualification for that is connected with profession
                  //- Ie me/mkf specifics
                  let machinesCert = this.currentUser.machinequalifications.filter((mq) => {
                    let profMachineIds = prof.machineOrientations.map(mo => mo.machineId)
                    return (profMachineIds.includes(mq.machineId) && mq.approvedById && mq.approvedById > 0)
                  })

                  if (machinesCert.length > 0) {
                    obj.id = tr.id
                    obj.profession = prof
                    obj.educationId = tr.educationId
                    obj.approvedOn = tr.approvedOn
                    obj.regionId = tr.regionId
                    obj.machineOrientations = machinesCert
                    obj.issuedOn = tr?.issuedOn
                    this.instQualifications.push(obj)
                    this.tradeCertificates.push({
                      ...tr, ...{title: this.getProfessionNameById(tr.professionId)},
                      machinesCert
                    });
                  }
                }
              })
            }

            if (this.currentUser && this.currentUser.educations) {
              //this.maQualifications = this.currentUser.machinequalifications
              this.currentUser.educations.forEach(ed => {
                if (
                    ed.basicEducationCertificate != null &&
                    ed.educationProfessionOrientations != null &&
                    ed.educationProfessionOrientations.length > 0 &&
                    ed.qualificationTime !== null
                ) {
                  if (ed.qualificationTime.fromDate) {
                    this.datesQTime.startDate = ed.qualificationTime.fromDate
                  }
                  if (ed.qualificationTime.toDate) {
                    this.datesQTime.endDate = ed.qualificationTime.toDate
                  }
                  let qTimeObj = {}
                  ed.educationProfessionOrientations.forEach(po => {
                    qTimeObj = po.professionMachineOrientation
                    qTimeObj.educationId = po.educationId
                    qTimeObj.region = ed.region

                    this.qTimeQualifications.push(qTimeObj)
                  })
                } else if (
                    //all courses with type=1 need to be approved
                    ed.basicEducationCertificate == null &&
                    ed.educationProfessionOrientations &&
                    ed.educationProfessionOrientations.length > 0 &&
                    this.currentUser.distanceMachineQualifications &&
                    this.currentUser.distanceMachineQualifications.filter(ma => ma.distanceEducationProviderCourse.type == 1)
                        .length > 0
                ) {
                  let found = !this.currentUser.distanceMachineQualifications
                      .filter(dist => dist.distanceEducationProviderCourse.type == 1)
                      .find(course => !course.approved)

                  if (found && SugarDate.Date.isBetween(new Date(), ed.startDate, ed.endDate)) {
                    this.datesGU.startDate = ed.startDate
                    this.datesGU.endDate = ed.endDate
                    let guObj = {}
                    ed.educationProfessionOrientations.forEach(po => {
                      guObj = po.professionMachineOrientation
                      guObj.educationId = po.educationId
                      guObj.region = ed.region

                      this.guTimeQualifications.push(guObj)
                    })
                  }
                }
              })
            }

            let counter = 0
            if (this.guTimeQualifications.length > 0) {
              counter++
            }
            if (this.qTimeQualifications.length > 0) {
              counter++
            }
            if (this.maQualifications.length > 0) {
              counter++
            }
            if (counter > 1) {
              this.showTitles = true
            } else {
              this.showTitles = false
            }
            if (
                this.currentUser &&
                this.currentUser.tradeCertificates &&
                this.currentUser.tradeCertificates.length > 0
            ) {
              this.currentUser.tradeCertificates.forEach(t => {
                if (t.approvedById && t.approvedById > 0) {
                  this.tradeCertId = t.id

                  return
                }
              })
            }
          })
    },
    getInstructions() {
      API.getInstructions()
          .then(({data}) => {
            const commitedDate = data.committedAt
            const lastReadInstructions = this.currentUser.readInstructionsOn
            if (lastReadInstructions) {
              this.shouldReadInstructions = new SugarDate.Date(commitedDate).isAfter(lastReadInstructions).raw
            }
          })
          .catch(error => {
            console.log('Error', error)
          })
    },
    showGUCard() {
      this.openGUCard = true
    },
    closeGUCard() {
      this.openGUCard = false
    },
    closeQtimeCard() {
      this.openQtimeCard = false
    },
    listEducationTypes() {
      return API.listEducationTypes()
          .then(res => {
            this.educationTypes = res.data
          })
          .catch(error => {
            console.log('error:', error)
          })
    },
    getYear(date) {
      if (!date) return ''
      return SugarDate.Date(date).format('%Y')
    },
    openHashModal(type, id) {
      let call = 'getMachineHash'
      if (type == 'education') call = 'getEducationHash'
      else if (type == 'distance') call = 'getDistanceQualificationHash'
      else if (type == 'tradeCert') call = 'getHash'

      API[call](id)
          .then(res => {
            this.qrValue = window.location.origin + '/qr-validation/' + res.data
            this.openQr = true
          })
          .catch(error => {
            console.log('error:', error)
          })
    },

    getEducationName(type) {
      if (type) {
        const et = find(this.educationTypes, {type: type})
        if (et && et.name) return et.name
        else return 'Ej angivet'
      } else {
        return 'Ej angivet'
      }
    },
    closeQrModal() {
      this.openQr = false
    }
  }
}
</script>

<style scoped lang="scss"></style>

